<div class="c-gp-credits {{#if mapOpened}}over-the-map{{/if}}">
	{{#if remainingRequests !== null && availableRequests !== null && resetsInStr !== null}}
		<div class="credits-wrapper">
			<div class="credits_data">
				<div class="credits_data_rate">
					<span class="credits_data_rate_header">Rate limit:</span>
					<span class="credits_data_rate_details">
						<span class="credits_data_rate_details_numbers">
							<span class="credits_data_rate_details_numbers_credits-count">
								{{remainingRequests}}/{{availableRequests}}
							</span>

							{{#if consumedRateLimit}}
								<span class="credits_data_rate_details_numbers_probes-count">
									(-{{consumedRateLimit}})
								</span>
							{{/if}}
						</span>

						<img as-tooltip="'Resets in ' + resetsInStr"
							width="14"
							height="14"
							src="{{@shared.assetsHost}}/img/help-icon.svg">
					</span>
				</div>

				{{#if creditsDataPresented}}
					<div class="credits_data_credits">
						<span class="credits_data_credits_header">
							Credits:
						</span>

						<span class="credits_data_rate_details">
							<span class="credits_data_rate_details_remaining-credits">
								{{remainingCredits}}
							</span>

							{{#if consumedCredits}}
								<span class="credits_data_rate_details_consumed-credits">
									(-{{consumedCredits}})
								</span>
							{{/if}}
						</span>
					</div>
				{{/if}}
			</div>

			<a href="https://dash.globalping.io?view=add-credits" class="credits_add" target="_blank">
				+ Add Credits
			</a>

			{{#if testInProgress && isInfiniteModeRes && consumingValue}}
				<div class="credits_consuming">
					<img width="14"
						height="14"
						src="{{@shared.assetsHost}}/img/alert-icon-alt.svg">

					<span>Consuming ~{{consumingValue}} API credits/minute</span>
				</div>
			{{/if}}
		</div>
	{{/if}}
</div>

<script>
	const tooltip = require('../../assets/js/decorators/tooltip');

	component.exports = {
		decorators: {
			tooltip,
		},
		data () {
			return {
				consumingValue: null,
				remainingRequests: null,
				availableRequests: null,
				consumedRateLimit: null,
				remainingCredits: null,
				consumedCredits: null,
				resetsInStr: null,
				creditsDataPresented: false,
				overallProbesCount: 0,
				sessionTimestampStart: null,
				sessionTimestampCurrent: null,
			};
		},
		oninit () {
			if (!Ractive.isServer) {
				// set session start time when test is started
				// SHOULD BE THE FIRST OBSERVE
				this.observe('testInProgress', (testInProgress) => {
					if (testInProgress) {
						this.set('sessionTimestampStart', Date.now());
						this.set('sessionTimestampCurrent', Date.now());
						this.set('consumedRateLimit', 0);
						this.set('consumedCredits', 0);
					} else {
						this.set('sessionTimestampStart', null);
						this.set('sessionTimestampCurrent', null);
						this.set('overallProbesCount', 0);
					}
				});

				this.observe('rateCreditsData', (rateCreditsData) => {
					if (rateCreditsData && rateCreditsData['x-ratelimit-limit']) {
						let rateLimitConsumed = Number(rateCreditsData['x-ratelimit-consumed']) || 0;
						let rateLimitRemaining = Number(rateCreditsData['x-ratelimit-remaining']) || 0;
						let rateLimitLimit = Number(rateCreditsData['x-ratelimit-limit']) || 0;
						let rateLimitReset = Number(rateCreditsData['x-ratelimit-reset']) || 0;
						let currentProbesCount = Number(rateCreditsData['x-request-cost']) || 0;
						let rateCreditsConsumed = Number(rateCreditsData['x-credits-consumed']) || 0;
						let rateCreditsRemaining = Number(rateCreditsData['x-credits-remaining']) || 0;

						if (this.get('isInfiniteModeRes')) {
							rateLimitConsumed += this.get('consumedRateLimit') || 0;
							rateCreditsConsumed += this.get('consumedCredits') || 0;
						}

						this.set('currentProbesCount', currentProbesCount);

						// handle RateLimit headers
						this.set('remainingRequests', rateLimitRemaining);
						this.set('availableRequests', rateLimitLimit);
						this.set('resetsInStr', this.createResetInStr(rateLimitReset));
						this.set('overallProbesCount', this.get('overallProbesCount') + currentProbesCount);
						this.set('consumedRateLimit', rateLimitConsumed);

						// handle Credits headers

						if (rateCreditsRemaining) {
							this.set('creditsDataPresented', true);
							this.set('consumedCredits', rateCreditsConsumed);
							this.set('remainingCredits', rateCreditsRemaining);
						} else {
							this.set('creditsDataPresented', false);
						}
					} else {
						// reset to default for a new measurement
						this.set('consumingValue', null);
						this.set('remainingRequests', null);
						this.set('availableRequests', null);
						this.set('consumedRateLimit', null);
						this.set('remainingCredits', null);
						this.set('consumedCredits', null);
						this.set('resetsInStr', null);
						this.set('creditsDataPresented', false);
						this.set('overallProbesCount', 0);
						this.set('sessionTimestampStart', null);
						this.set('sessionTimestampCurrent', null);
					}
				});

				// update current timestamp on receiving testResults
				this.observe('testResults', (testResults) => {
					if (testResults) {
						this.set('sessionTimestampCurrent', Date.now());
					}
				});

				// calculate consuming value
				this.observe('testResults.length', () => {
					let measurementsCount = this.get('testResults.length');

					if (measurementsCount < 2) {
						return;
					}

					let sessionTimestampCurrent = this.get('sessionTimestampCurrent');
					let overallProbesCount = this.get('overallProbesCount');
					let sessionTimestampStart = this.get('sessionTimestampStart');
					let sessionTime = Math.round((sessionTimestampCurrent - sessionTimestampStart) / 1000);
					let consumingValuePerSecond = (overallProbesCount - this.get('currentProbesCount')) / (sessionTime || 1);

					this.set('consumingValue', Math.round(consumingValuePerSecond * 60));
				}, { init: false });
			}
		},
		createResetInStr (seconds) {
			let minutes = seconds / 60;

			if (minutes < 1) {
				return '< 1 minute';
			}

			return `${Math.ceil(minutes)} minutes`;
		},
	};
</script>
